import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { AnimatePresence, motion } from "framer-motion";
import { useRef } from "react";
import { NavLink, useParams } from "react-router-dom";
import useWidth from "../../hooks/widthHook";

const NavBarAccordion = ({ title, onClick, open, items, toggleMenu }) => {
  const ref = useRef(null);
  const params = useParams();
  const { id } = params;
  const width = useWidth(ref);

  return (
    <div className="w-full">
      <button
        ref={ref}
        onClick={onClick}
        className="group flex w-full items-center justify-between gap-5 py-2"
      >
        <p
          className={`text-start text-base font-normal text-visBlue group-hover:text-visOrange ${items.some((val) => val.href === id) && "text-visOrange"}`}
        >
          {title}
        </p>
        <motion.div
          initial={false}
          animate={{ rotate: open ? 90 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <ChevronRightIcon
            className={`size-5 font-thin text-visBlue group-hover:text-visOrange ${items.some((val) => val.href === id) && "text-visOrange"}`}
          />
        </motion.div>
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, marginTop: "0rem" }}
            animate={{ height: "auto", marginTop: "0.0rem" }}
            exit={{ height: 0, marginTop: "0rem" }}
            transition={{ duration: 0.3, ease: "linear" }}
            className="w-full overflow-hidden"
          >
            {items.map((item, idx) => {
              return (
                <NavLink
                  key={idx}
                  onClick={toggleMenu}
                  to={`/services/detail/${item.href}`}
                  className={`mx-4 block max-w-full py-2 text-sm text-visBlue hover:text-visOrange md:text-base ${item.href === id && "text-visOrange"}`}
                >
                  {item.label}
                </NavLink>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NavBarAccordion;
